import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { useThemeColors } from '@/hooks/residents/useThemeColors';
import { REDESIGN_TYPOGRAPHY } from '@/constants/residents/homeConstants';

export const EmptyMessageWindow: React.FC = () => {
  const { colors } = useThemeColors();

  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <RESIDENTS_SVG_COMPONENTS.EMPTY_INBOX
          width={120}
          height={120}
          color={colors.text.subtle}
        />
      </View>
      <Text style={[styles.title, { color: colors.text.primary }]}>New Message</Text>
      <Text style={[styles.subtitle, { color: colors.text.subtle }]}>
        Click the "New message" button to start compiling your message
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 32,
    paddingVertical: 64,
  },
  iconContainer: {
    marginBottom: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    ...REDESIGN_TYPOGRAPHY.sectionTitle,
    marginBottom: 8,
    textAlign: 'center',
  },
  subtitle: {
    ...REDESIGN_TYPOGRAPHY.body,
    textAlign: 'center',
    lineHeight: 20,
  },
});

export default EmptyMessageWindow;
